import { forwardRef, type SelectHTMLAttributes } from "react";
import { cx } from "./cx";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options?: ReadonlyArray<SelectOption>;
  invalid?: boolean;
  /** Optional placeholder option rendered first (value=""). */
  placeholder?: string;
}

/**
 * Select — native <select> (keyboard + AT friendly by construction) wrapped for the chevron and
 * token styling. Pass either `options` or children <option>s.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, invalid, placeholder, className, children, "aria-invalid": ariaInvalid, ...rest },
  ref,
) {
  return (
    <span className="nv-select-wrap">
      <select
        ref={ref}
        className={cx("nv-field", invalid && "nv-field--invalid", className)}
        aria-invalid={ariaInvalid ?? invalid ?? undefined}
        {...rest}
      >
        {placeholder !== undefined && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options
          ? options.map((o) => (
              <option key={o.value} value={o.value} disabled={o.disabled}>
                {o.label}
              </option>
            ))
          : children}
      </select>
    </span>
  );
});
